import { Font } from '@/constants';
import { createContext } from 'react';

export const FontsContext = createContext<ContextProps>({
	fonts: [],
	error: null,
	isLoading: false,
});

interface ContextProps {
	fonts: Array<Font>;
	error: Error | null;
	isLoading: boolean;
}
